import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '@base/environments/environment';
import { Constants } from '@base/src/app/models/constants';
import { QRInput } from 'src/app/models/qr-input.model';

export interface NotificationConfig {
  id: number;
  title: string;
  description: string;
  type: number;
  active: boolean;
  administration: boolean;
  agent: boolean;
  broker: boolean;
  manager: boolean;
  secretariate: boolean;
  visibleCheckAdministration: boolean;
  visibleCheckAgent: boolean;
  visibleCheckBroker: boolean;
  visibleCheckManager: boolean;
  visibleCheckNotification: boolean;
  visibleCheckSecretariate: boolean;
  quantityEditable: boolean;
  quantity: {
    quantity0: number | null;
    quantity1: number | null;
    quantity2: number | null;
    quantity3: number | null;
    quantity4: number | null;
    quantity5: number | null;
    quantity6: number | null;

    quantity7?: number | null;
    quantity8?: number | null;
    quantity9?: number | null;
    quantity10?: number | null;
    quantity11?: number | null;
    quantity12?: number | null;
    quantity13?: number | null;
  };
  notificationId: number;
}

@Component({
  selector: 'app-config-add-edit-notifications',
  templateUrl: './config-add-edit-notifications.component.html',
  styleUrls: ['./config-add-edit-notifications.component.scss'],
})
export class ConfigAddEditNotificationsComponent implements OnInit {
  @Input() value!: NotificationConfig;
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  readonly NODE = environment.node;
  readonly NODE_AR = Constants.TENANT_ID_AR;
  readonly NODE_EC = Constants.TENANT_ID_EC;
  readonly NODE_DO = Constants.TENANT_ID_DO;

  errors: Record<string, boolean> = {
    days: false,
  };

  quantity: {
    [key: string]: any;
    quantity0: number | null;
    quantity1: number | null;
    quantity2: number | null;
    quantity3: number | null;
    quantity4: number | null;
    quantity5: number | null;
    quantity6: number | null;

    // Opcionales (solo para DO)
    quantity7?: number | null;
    quantity8?: number | null;
    quantity9?: number | null;
    quantity10?: number | null;
    quantity11?: number | null;
    quantity12?: number | null;
    quantity13?: number | null;
  } = {
    quantity0: 0,
    quantity1: 0,
    quantity2: 0,
    quantity3: 0,
    quantity4: 0,
    quantity5: 0,
    quantity6: 0,
  };

  dataArray: { [key: string]: string } = {};

  inputNumber: QRInput = {
    mode: QRInput.MODE_INTEGER,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: '',
    debounceTime: 500,
  };

  ngOnInit(): void {
    this.initErrors();

    if (this.NODE !== this.NODE_DO) {
      this.dataArray['quantity0'] = 'Rookie';
      this.dataArray['quantity1'] = 'Executive';
      this.dataArray['quantity2'] = 'Club 100%';
      this.dataArray['quantity3'] = 'Platinum';
      this.dataArray['quantity4'] = 'Chairman';
      this.dataArray['quantity5'] = 'Titan';
      this.dataArray['quantity6'] = 'Diamond';
    } else {
      this.dataArray['quantity0'] = 'President';
      this.dataArray['quantity1'] = 'Executive';
      this.dataArray['quantity2'] = 'Executive +';
      this.dataArray['quantity3'] = '100%';
      this.dataArray['quantity4'] = '100% +';
      this.dataArray['quantity5'] = 'Platinum';
      this.dataArray['quantity6'] = 'Platinum +';
      this.dataArray['quantity7'] = 'Chairman';
      this.dataArray['quantity8'] = 'Chairman +';
      this.dataArray['quantity9'] = 'Titan';
      this.dataArray['quantity10'] = 'Titan +';
      this.dataArray['quantity11'] = 'Diamond';
      this.dataArray['quantity12'] = 'Diamond +';
      this.dataArray['quantity13'] = 'Pinnacle';
    }

    const IDS = [8, 13, 7, 6, 5];

    if (this.value?.quantity && IDS.includes(this.value?.notificationId)) {
      this.quantity = { ...this.value.quantity };
    }
  }

  initErrors() {
    const MAX = this.NODE === this.NODE_DO ? 13 : 6;

    for (let i = 0; i <= MAX; i++) {
      this.errors[`quantity${i}`] = false;
    }
  }

  public get filteredQuantityArray(): {
    key: string;
    label: string;
    value: number | null;
  }[] {
    const MAX = this.NODE === this.NODE_DO ? 13 : 6;

    const ARR = Object.keys(this.dataArray)
      .filter((key) => {
        const M = key.match(/^quantity(\d+)$/);
        return !!M && Number(M[1]) <= MAX;
      })
      .map((key) => {
        const IDX = Number(key.match(/^quantity(\d+)$/)![1]);
        return {
          key,
          index: IDX,
          label: this.dataArray[key] ?? `quantity${IDX}`,
          value: this.quantity[key] as number | null,
        };
      })
      .sort((a, b) => a.index - b.index)
      .map(({ key, label, value }) => ({ key, label, value }));
    return ARR;
  }

  changeNumber($event: any) {
    this.errors['days'] = true;
    if ($event && $event > 6 && $event < 29) {
      this.errors['days'] = false;
      this.value.quantity.quantity0 = Number($event);
    }
    this.checkForm();
  }

  changeRewards($event: any, key: any) {
    this.errors[key] = true;
    if (key && ($event || $event == 0)) {
      this.quantity[key] = $event;
      this.errors[key] = false;
      this.value.quantity = { ...this.quantity };
    }
    this.checkForm();
  }

  checkForm() {
    let result = true;
    Object.keys(this.errors).forEach((key: any) => {
      result = result && !this.errors[key];
    });
    this.change.emit('disabled');
    if (result) {
      this.change.emit(this.value);
    }
  }
}
